const selectors = {
  shopifySection: '[data-api-content]',
  drawer: '[data-inventory-drawer]',
  drawerOpen: '[data-inventory-drawer-open]',
  drawerClose: '[data-inventory-drawer-close]',
};

const classes = {
  isVisible: 'drawer--visible',
};

let sections = {};

class InventoryAvailability {
  constructor(section) {
    this.container = section.container;
    this.drawer = null;
    this.buttonDrawerOpen = null;
    this.buttonDrawerClose = null;

    if( this.container.querySelector(`[product-json-metafields]`) === null) {
      console.error('inventory data not ready yet.');
      return;
    }

    this.inventoryJSON = JSON.parse(this.container.querySelector(`[product-json-metafields]`).innerHTML);
    this.container.querySelector(`[data-inventory-drawer-open]`).classList.remove('hide');
    this.initDrawer();
    this.updateAvailability();
    // variant level
    // section.container.addEventListener('theme:variant:change', (event) => this.updateAvailability(event));
  }

  initDrawer() {
    this.drawer = document.querySelector(selectors.drawer);
    this.buttonDrawerOpen = this.container.querySelector(selectors.drawerOpen);
    this.buttonDrawerClose = document.querySelectorAll(selectors.drawerClose);

    if (this.buttonDrawerOpen) {
      this.buttonDrawerOpen.addEventListener('click', () => this.openDrawer());
    }

    if (this.buttonDrawerClose.length) {
      this.buttonDrawerClose.forEach((element) => {
        element.addEventListener('click', () => this.closeDrawer());
      });
    }
  }

  updateAvailability() {
    const drawer = this.drawer;
    const inventoryObject = this.inventoryJSON;
    this.drawer.querySelectorAll(`[data-variant-inventory-quantity]`).forEach((el) => {
      const locationId = el.getAttribute(`data-location-id`);
      const inventory = parseInt(inventoryObject[locationId]) || 0;
      if( inventory !== null ) {
        if( inventory > 0 ) {
          el.innerHTML = `<span data-inventory="${inventory}" style="color:#5c7f71;">Available</span>`;
        } else {
          el.innerHTML = `<span data-inventory="${inventory}" style="color:#b83a4b;">Unavailable</span>`;
        }
      } else {
        el.innerHTML = ``;
      }
    });
  }

  // variant level
  _updateAvailability(event) {
    const drawer = this.drawer;
    const variant = event.detail.variant;

    if (drawer && variant) {
      const inventoryObject = this.inventoryJSON[ variant.id ].location;

      this.drawer.querySelectorAll(`[data-variant-inventory-quantity]`).forEach((el) => {
        const locationId = el.getAttribute(`data-location-id`);
        const inventory = parseInt(inventoryObject[locationId]) || 0;
        if( inventory !== null ) {
          if( inventory > 0 ) {
            el.innerHTML = `<span data-inventory="${inventory}" style="color:#5c7f71;">Available</span>`;
          } else {
            el.innerHTML = `<span data-inventory="${inventory}" style="color:#b83a4b;">Unavailable</span>`;
          }
        } else {
          el.innerHTML = ``;
        }
      });
    }
  }

  openDrawer() {
    if (this.drawer) {
      this.drawer.classList.add(classes.isVisible);
      this.drawer.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
    }
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.classList.remove(classes.isVisible);
      this.drawer.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }
  }
}

const inventoryAvailability = {
  onLoad() {
    sections[this.id] = new InventoryAvailability(this);
  },
};

export default inventoryAvailability;